export const ACCESS_TOKEN_KEY = "Com.SCG.Chem.RND.CMS.Web.access_token";
export const ACCOUNT_INFO_KEY = "Com.SCG.Chem.RND.CMS.Web.acc";
export const REDIRECT_URL_KEY = "Com.SCG.Chem.RND.CMS.Web.redirect_url";
export const CURREN_LANG = "Com.SCG.Chem.RND.CMS.Web.current_lang";

export const DATE_FORMAT = "dd MMM yyyy";
export const DATETIME_FORMAT = "dd MMM yyyy HH:mm";
export const DATETIME_BACKEND_FORMAT = "yyyy-MM-ddTHH:mm:ssZ";
